/* metro-ui-components@9.20.0 */
"use strict";
/* Higher order component, used to disable tabbing outside of it's children
 * Use
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./tabTrap.css'); }
var cssBaseClass = "tab-trap";
var KEY_DOWN_EVENT = "keydown";
var TAB_KEY_CODE = 9;
exports.tabTrap = function () { return function (Component) {
    var _a;
    return _a = /** @class */ (function (_super) {
            tslib_1.__extends(TabTrap, _super);
            function TabTrap(props) {
                var _this = _super.call(this, props) || this;
                _this.tabTrap = null;
                _this.tabTrapBegin = null;
                _this.tabTrapEnd = null;
                _this.handleInnerKeyDown = _this.handleInnerKeyDown.bind(_this);
                _this.handleOuterKeyDown = _this.handleOuterKeyDown.bind(_this);
                _this.enableTabbing = _this.enableTabbing.bind(_this);
                _this.disableTabbing = _this.disableTabbing.bind(_this);
                return _this;
            }
            TabTrap.prototype.componentDidMount = function () {
                this.disableTabbing();
                if (this.immediateDisable) {
                    this.immediateDisable = false;
                }
            };
            TabTrap.prototype.componentWillUnmount = function () {
                this.immediateDisable = false;
                this.enableTabbing();
            };
            TabTrap.prototype.handleInnerKeyDown = function (event) {
                if (event.keyCode !== TAB_KEY_CODE) {
                    return;
                }
                event.stopPropagation();
                if (!event.shiftKey && event.target === this.tabTrapEnd) {
                    event.preventDefault();
                    this.tabTrapBegin.focus();
                }
                else if (event.shiftKey && event.target === this.tabTrapBegin) {
                    event.preventDefault();
                    this.tabTrapEnd.focus();
                }
            };
            TabTrap.prototype.handleOuterKeyDown = function (event) {
                if (event.keyCode !== TAB_KEY_CODE) {
                    return;
                }
                if (event.shiftKey && this.tabTrapEnd) {
                    this.tabTrapEnd.focus();
                }
                else if (this.tabTrapBegin) {
                    this.tabTrapBegin.focus();
                }
            };
            TabTrap.prototype.disableTabbing = function () {
                var _this = this;
                document.body.addEventListener(KEY_DOWN_EVENT, this.handleOuterKeyDown);
                if (!this.tabTrap) {
                    // Component immediatly called disableTabbing
                    // but TabTraps ref has not been rendered yet: call when mounted
                    this.immediateDisable = true;
                }
                else {
                    this.tabTrap.addEventListener(KEY_DOWN_EVENT, this.handleInnerKeyDown);
                }
                setTimeout(function () {
                    if (_this.tabTrapBegin) {
                        _this.tabTrapBegin.focus();
                    }
                }, 200);
            };
            TabTrap.prototype.enableTabbing = function () {
                document.body.removeEventListener(KEY_DOWN_EVENT, this.handleOuterKeyDown);
                if (this.tabTrap) {
                    this.tabTrap.removeEventListener(KEY_DOWN_EVENT, this.handleInnerKeyDown);
                }
            };
            TabTrap.prototype.renderTabTrap = function (isEnd) {
                var _this = this;
                if (isEnd === void 0) { isEnd = false; }
                return (React.createElement("a", { ref: function (element) {
                        if (isEnd) {
                            _this.tabTrapEnd = element;
                        }
                        else {
                            _this.tabTrapBegin = element;
                        }
                    }, className: cssBaseClass, href: "#", onClick: function (e) { return e.preventDefault(); } }, "tabtrap"));
            };
            TabTrap.prototype.renderTabTrapBegin = function () {
                return this.renderTabTrap();
            };
            TabTrap.prototype.renderTabTrapEnd = function () {
                return this.renderTabTrap(true);
            };
            TabTrap.prototype.render = function () {
                var _this = this;
                return (React.createElement(Component, tslib_1.__assign({}, this.props),
                    React.createElement("div", { ref: function (element) { return (_this.tabTrap = element); }, className: "tab-trap-root" },
                        this.renderTabTrapBegin(),
                        this.props.children,
                        this.renderTabTrapEnd())));
            };
            return TabTrap;
        }(React.Component)),
        _a.displayName = Component.displayName || Component.name,
        _a;
}; };